import React, { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { instructorsDetailList } from "../../../data/instructors";
import * as S from "./styled";
import InstagramIcon from "../../../assets/images/common/black-instagramicon.png";
import Icon from "../../../components/Icon";

import AOS from "aos";
import { Helmet } from "react-helmet-async";

const InstructorDetail = () => {
  const { name } = useParams();

  const [instructor, setInstructor] = useState<any>(null);

  useEffect(() => {
    const foundInstructor = instructorsDetailList.find(
      (instructor) => instructor.name === name
    );
    setInstructor(foundInstructor);
  }, [name]);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const isReactSnap = navigator.userAgent === "ReactSnap";

    if (!isReactSnap) {
      AOS.init();
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, []);
  if (!instructor) {
    return <div>해당 강사를 찾을 수 없습니다.</div>;
  }

  return (
    <>
      <Helmet>
        <title>넵튠 댄스 스튜디오 | 셔플 풋워크 전문 학원</title>

        <meta
          name="description"
          content="셔플 풋워크 전문 트레이닝 센터 | 기초부터 전문인 양성까지"
        />

        <meta
          name="keywords"
          content="넵튠, 넵튠 댄스, 넵튠 댄스 스튜디오, 셔플, 셔플댄스학원, 댄스자격증, 풋워크 수업, 국제실용댄스지도자협회, 국제실용댄스, 풋워크"
        />

        <meta property="og:title" content="넵튠 댄스 스튜디오" />
        <meta
          property="og:description"
          content="셔플 풋워크 전문 트레이닝 센터 | 기초부터 전문인 양성까지"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="http://neptunedance.com" />
        <meta
          property="og:image"
          content="http://neptunedance.com/og-image.png"
        />
      </Helmet>
      {instructor && (
        <S.InstructorDetailWrapper>
          <div className="inner">
            <S.InstructorDetailWrap>
              <div
                className="img-area"
                data-aos="fade"
                data-aos-duration={500}
                data-aos-easing="linear"
              >
                <img src={instructor.img} alt={instructor.title} />
              </div>
              <div className="text-area">
                <div
                  className="title-wrap"
                  data-aos="fade"
                  data-aos-duration={500}
                  data-aos-easing="linear"
                >
                  <h6>{instructor.name}</h6>
                  <NavLink to={instructor.instagram} target="_blank">
                    <Icon>
                      <img src={InstagramIcon} alt="instagram icon" />
                    </Icon>
                  </NavLink>
                </div>
                <div className="class-wrap">
                  {instructor.class && instructor.class.length > 0 && (
                    <dl>
                      <dt
                        data-aos="fade-up"
                        data-aos-duration={500}
                        data-aos-easing="linear"
                        data-aos-delay={200}
                      >
                        담당 클래스
                      </dt>

                      <dd
                        data-aos="fade-left"
                        data-aos-duration={500}
                        data-aos-easing="linear"
                        data-aos-delay={200}
                      >
                        {instructor.class.length > 0
                          ? instructor.class.map((classText: string) => {
                              if (classText.includes(" | ")) {
                                const [time, level] = classText.split(" | ");
                                return (
                                  <p key={classText}>
                                    <span>{time}</span>
                                    <span>| {level}</span>
                                  </p>
                                );
                              } else {
                                return <p key={classText}>{classText}</p>;
                              }
                            })
                          : null}
                      </dd>
                    </dl>
                  )}
                  <NavLink to={instructor.reservation}>수업 예약하기</NavLink>
                </div>
                <div className="career-wrap">
                  <dl>
                    <dt
                      data-aos="fade-up"
                      data-aos-duration={500}
                      data-aos-easing="linear"
                      data-aos-delay={200}
                    >
                      경력
                    </dt>
                    <dd
                      data-aos="fade-left"
                      data-aos-duration={500}
                      data-aos-easing="linear"
                      data-aos-delay={300}
                    >
                      {instructor.career.length > 0 &&
                        instructor.career.map((careerText: string) => (
                          <p key={careerText}>{careerText}</p>
                        ))}
                    </dd>
                  </dl>
                </div>
              </div>
            </S.InstructorDetailWrap>
          </div>
        </S.InstructorDetailWrapper>
      )}
    </>
  );
};

export default InstructorDetail;
